export const Destination = Object.freeze({
    fbpixel: "fbpixel", //Meta Pixel
    fbcapi: "fbcapi", // Meta Conversions Api
    fboffline: "fboffline", // Meta Offline Conversions
    fbca: "fbca", // Meta Custom Audience
    ttpixel: "ttpixel", // TikTok Pixel
    ttcapi: "ttcapi", // TikTok Web Events Api
    ttoffline: "ttoffline", // TikTok Offline Events
    ttapp: "ttapp", // TikTok App Events
    ttca: "ttca", // TikTok Custom Audience
    ttmessaging: "ttmessaging", // TikTok Messaging
    scpixel: "scpixel", // Snap Pixel
    sccapi: "sccapi", // Snap Conversions API
    pnpixel: "pnpixel", // Pinterest Tag
    pncapi: "pncapi", // Pinterest Conversion Api
    ggads: "ggads", // Google Offline Conversions
    ggads_web: "ggads_web", // Google Web Conversions
    ggads4: "ggads4", // Google Analytics 4
    ggbq: "ggbq", // Google BigQuery
    ggawc: "ggawc", // Google Ads Website Conversion
    ggaoc: "ggaoc", // Google Ads Offline Conversion
    ggalc: "ggalc", // Google Ads Lead Conversion
    ggass: "ggass", // Google Ads Store Sales
    twpixel: "twpixel", // X Pixel
    twcapi: "twcapi", // X Conversion Api
    alpixel: "alpixel", // Applovin Pixel
    rdpixel: "rdpixel", // Reddit Pixel
    rdcapi: "rdcapi", // Reddit Conversions Api
    imcapi: "imcapi", // Impact
    sstask: "sstask", // SignalSight Task
    licapi: "licapi", // LinkedIn Conversions Api
    msoffline: "msoffline", // Microsoft Bing Offline Conversions
    ymwc: "ymwc", // Yandex Metrica Web Conversions
    oaipixel: "oaipixel", // OpenAI Ads Pixel
    oaicapi: "oaicapi", // OpenAI Ads Conversions API
});
